"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageState = void 0;
exports.defaultMortgageState = {
    price: 8000000,
    downPayment: 800000,
    interestRate: 3.5,
    durationInMonth: 360,
    paymentPerMonth: 0,
    initialCashOutlay: 0,
    interest: 0,
    stampDuty: 0,
    commission: 0,
    mortgage: 0,
    buyerStampDuty: false,
    adValoremStampDuty: false,
    hasOutstandingMortgage: false,
    hasTransactedRecently: false,
    hasTransactedRecentlyMonth: 6,
    hasTransactedRecentlyMonths: [6, 12, 36],
    insurance: 0,
    stressTestMonthlyIncome: 0,
    amortizeTable: [],
    rateTable: [],
    totalExpense: 0,
    activeIndex: -1,
    error: null,
    hasExtraStampDuty: false,
};
